var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dice",class:_vm.diceClass})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /Users/Smelkov/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c6e2f5a","hasScoped":false,"buble":{"transforms":{}}}!/Users/Smelkov/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Dice.vue
// module id = 17
// module chunks = 0